import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { SocketURL } from '../constants/base.url';
import { Message } from '../models/message';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket!: Socket;

  connect(token: string) {
    this.socket = io(SocketURL, {
      transports: ['websocket'], // ensure websocket connection
      autoConnect: true,         // auto connect when initialized
    });

    // Wait for connection to establish
    this.socket.on('connect', () => {
      console.log('✅ Socket connected with ID:', this.socket.id);
      // Now safely join community
      this.socket.emit('joinCommunity', token);
    });

    this.socket.on('connect_error', (err) => {
      console.error('❌ Socket connection error:', err);
    });
  }

  // Listen for new messages
  onNewMessage(callback: (msg: Message) => void) {
    this.socket.on('newMessage', callback);
  }

  // Emit new message
  // ✅ Update this method to accept both string or object
  sendMessage(message: string | { content: string; tempId: string }): void {
    if (typeof message === 'string') {
      this.socket.emit('sendMessage', { content: message });
    } else {
      this.socket.emit('sendMessage', message);
    }
  }

  // Disconnect socket
  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      console.log('🔌 Socket disconnected');
    }
  }
}
